interface MetricCardProps {
  icon: string;
  value: string | number;
  label: string;
  trend?: string;
  trendUp?: boolean;
  accent?: boolean;
}

export default function MetricCard({ icon, value, label, trend, trendUp, accent }: MetricCardProps) {
  return (
    <div className={`bg-white border border-[#E0E0E0] p-4 ${accent ? 'border-t-2 border-t-[#C41230]' : 'border-t-2 border-t-[#111111]'}`}>
      <div className="flex items-start justify-between mb-3">
        <div className="w-8 h-8 flex items-center justify-center bg-[#F8F8F8] border border-[#E0E0E0]">
          <i className={`${icon} text-[#444444] text-sm`}></i>
        </div>
        {trend && (
          <span className={`text-[10px] font-semibold font-sans flex items-center gap-0.5 ${trendUp ? 'text-[#1a7a1a]' : 'text-[#C41230]'}`}>
            <i className={trendUp ? 'ri-arrow-up-line text-xs' : 'ri-arrow-down-line text-xs'}></i>
            {trend}
          </span>
        )}
      </div>
      <p className="text-3xl font-bold text-[#111111] font-serif mb-0.5">{value}</p>
      <p className="text-[11px] text-[#666666] font-sans uppercase tracking-wide">{label}</p>
    </div>
  );
}
